const RESERVED_USERNAMES = new Set([
  'login',
  'signup',
  'onboarding',
  'select-role',
  'settings',
  'admin',
  'support',
  'api',
  'privacy',
  'terms',
  'dashboard',
  'explore',
  'home',
  'u',
  'user',
  'users',
  'creator',
  'creators',
  'brand',
  'brands',
]);

export const normalizeUsername = (input: string) => input.trim().toLowerCase();

export const validateUsername = (input: string) => {
  const trimmed = input.trim();
  const username = normalizeUsername(input);

  if (!username) {
    return { ok: false, reason: 'Username is required.' };
  }

  if (/\s/.test(trimmed)) {
    return { ok: false, reason: 'Username cannot contain spaces.' };
  }

  if (username.length < 3 || username.length > 20) {
    return { ok: false, reason: 'Username must be 3–20 characters.' };
  }

  if (!/^[a-z][a-z0-9_]*$/.test(username)) {
    return {
      ok: false,
      reason: 'Use lowercase letters, numbers, and underscores only.',
    };
  }

  if (username.endsWith('_')) {
    return { ok: false, reason: 'Username cannot end with an underscore.' };
  }

  if (username.includes('__')) {
    return { ok: false, reason: 'Username cannot contain consecutive underscores.' };
  }

  if (RESERVED_USERNAMES.has(username)) {
    return { ok: false, reason: 'This username is reserved.' };
  }

  return { ok: true, value: username };
};
